import Layout from "@/components/layout/Layout";

const mediaTools = [
  {
    name: "Midjourney V7",
    type: "תמונות",
    description: "נחשב למנוע יצירת התמונות האיכותי ביותר בשוק. גרסה V7 (שוחררה אפריל 2025) היא ברירת המחדל, בעוד V8 נמצאת בפיתוח מתקדם. כיום המערכת נגישה דרך ממשק ווב ייעודי ומתקדם בנוסף ל-Discord.",
    pros: "איכות ויזואלית פוטו-ריאליסטית, שליטה אמנותית מוחלטת, ממשק ווב נוח.",
    pricing: "Basic $10/חודש, Standard $30/חודש, Pro $60/חודש.",
    url: "https://midjourney.com"
  },
  {
    name: "Runway Gen-4.5",
    type: "וידאו",
    description: "פלטפורמת הוידאו המובילה שהשיגה את הציון הגבוה ביותר בבנצ'מרק Text-to-Video העולמי. המערכת כוללת כעת גם אינטגרציה מלאה ל-Veo 3/3.1 של גוגל בתוך סביבת העבודה.",
    pros: "עמידה בסטנדרטים קולנועיים, כלי עריכה מבוססי AI, גישה למודלים חיצוניים.",
    pricing: "מנויים החל מ-$12/חודש.",
    url: "https://runwayml.com"
  },
  {
    name: "Sora 2 (OpenAI)",
    type: "וידאו",
    description: "הדור השני של מודל הוידאו של OpenAI. המודל זמין כעת לכל מנויי ChatGPT Plus ו-Pro. מאפשר יצירת סרטונים באורך של עד 25 שניות עם אודיו מסונכרן מובנה באיכות גבוהה.",
    pros: "ריאליזם קיצוני, הבנה פיזיקלית של סצנות, אודיו מובנה.",
    pricing: "כלול ב-Plus ($20) ו-Pro ($200) של OpenAI.",
    url: "https://openai.com/sora"
  },
  {
    name: "Google Veo 3.1",
    type: "וידאו",
    description: "מנוע הוידאו המתקדם של גוגל. תומך ברזולוציית 4K וסרטונים באורך של עד 60 שניות. כולל אודיו מובנה עם הגנת SynthID. זמין דרך Google AI Studio ו-YouTube Shorts.",
    pros: "איכות 4K, אורך סרטון משמעותי, אינטגרציה עם מוצרי גוגל.",
    pricing: "מודל תמחור לפי שנייה (Usage-based).",
    url: "https://deepmind.google/technologies/veo"
  },
  {
    name: "Kling AI 2.6",
    type: "וידאו",
    description: "מודל וידאו עוצמתי המאפשר יצירת סרטונים ארוכים במיוחד של עד 3 דקות. הגרסה החדשה כוללת מנוע ליצירת אודיו מסונכרן (Foley) המותאם לנעשה בסצנה.",
    pros: "סרטונים ארוכים מאוד, תנועה טבעית, סנכרון אודיו מרשים.",
    pricing: "קרדיטים חינמיים חודשיים, מנויים מ-$12/חודש.",
    url: "https://klingai.com"
  },
  {
    name: "Ideogram",
    type: "תמונות / טיפוגרפיה",
    description: "מתמחה ביצירת תמונות הכוללות טקסט מדויק וקריא, משימה שהייתה קשה מאוד למודלי AI בעבר. מעולה לעיצוב לוגואים ופוסטרים.",
    pros: "דיוק טקסטואלי מושלם, סגנונות גרפיים מגוונים.",
    pricing: "תוכנית חינמית מוגבלת, מנוי Pro ב-$20.",
    url: "https://ideogram.ai"
  },
  {
    name: "Pika 2.5",
    type: "וידאו",
    description: "כלי ליצירת וידאו מהיר המתמקד באפקטים יצירתיים וייחודיים כמו Pikaswaps ו-Pikaffects לשינוי אלמנטים בתוך הוידאו.",
    pros: "מהירות יצירה, אפקטים ייחודיים וקלים לשימוש.",
    pricing: "מנויים החל מ-$8/חודש.",
    url: "https://pika.art"
  },
  {
    name: "Leonardo AI",
    type: "תמונות",
    description: "פלטפורמת יצירה המציעה ממשק נוח במיוחד עם שליטה ידנית בפרמטרים רבים, אימון מודלים אישיים ויכולות עריכה (Canvas) מתקדמות.",
    pros: "ממשק משתמש מצוין, מגוון רחב של מודלים מובנים.",
    pricing: "מנוי חינמי נדיב, מנויים בתשלום לשימוש עסקי.",
    url: "https://leonardo.ai"
  },
  {
    name: "DALL-E 3 (OpenAI)",
    type: "תמונות",
    description: "מודל יצירת התמונות המובנה ישירות ב-ChatGPT. מצטיין בהבנת הנחיות (Prompts) מורכבות וביצוע מדויק של בקשות המשתמש.",
    pros: "קלות שימוש מקסימלית, הבנת שפה טבעית מעולה.",
    pricing: "זמין לכל משתמשי ChatGPT (מגבלות משתנות).",
    url: "https://openai.com/dall-e-3"
  }
];

const AIMediaTools = () => {
  return (
    <Layout>
      <div className="bg-white min-h-screen pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <header className="mb-20 text-right">
            <p className="text-xs font-bold tracking-widest text-slate-400 uppercase mb-3">מדיה ויצירה</p>
            <h1 className="text-4xl font-black text-slate-900 tracking-tight mb-4">כלי AI גרפיקה/סרטונים</h1>
            <p className="text-lg text-slate-500 leading-relaxed max-w-2xl font-light">
              הכלים החזקים ביותר להפקת תוכן ויזואלי, מיצירת תמונות אמנותיות ועד סרטוני וידאו ריאליסטיים מטקסט. נכון לפברואר 2026.
            </p>
          </header>

          <div className="space-y-8">
            {mediaTools.map((tool, idx) => (
              <div key={idx} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 transition-shadow hover:shadow-sm">
                <div className="flex justify-between items-start mb-6">
                  <h3 className="text-2xl font-bold text-slate-900">{tool.name}</h3>
                  <span className="text-[10px] font-bold text-white bg-slate-900 px-2 py-1 rounded tracking-widest uppercase">
                    {tool.type}
                  </span>
                </div>
                
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="text-right">
                    <p className="text-slate-600 leading-relaxed text-sm">
                      {tool.description}
                    </p>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">יתרונות</span>
                      <p className="text-xs text-slate-600 leading-relaxed">{tool.pros}</p>
                    </div>
                    <div className="flex justify-between items-end">
                       <div>
                        <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">מחירון</span>
                        <p className="text-xs text-slate-900 font-bold">{tool.pricing}</p>
                       </div>
                       <a 
                        href={tool.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-[10px] font-bold text-blue-600 uppercase tracking-widest hover:underline"
                      >
                        מעבר לאתר
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AIMediaTools;